import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'spinner',
    styleUrls: ['./spinner.scss'],
    template: `
    		<div id="chart-spinner">
    		  @if (isLoading | async) {
    		    <div id="spinner" [class.show]="isLoading | async">
    		      <h1><i class="fas fa-spinner fa-spin"></i></h1>
    		    </div>
    		  }
    		</div>`,
    host: { 'cid': 'spinner' },
    imports: [AsyncPipe]
})
export class SpinnerComponent {
    @Input() isLoading: boolean;
}
